export default {
  tutorials: [],
  tutorials_errors: [],
  tutorials_loading: false,
  tutorial_detail: {},
  tutorial_errors: [],
  tutorial_loading: false,

};
